import axios from 'axios';
import { app } from '@root/env';

const baseURL = app.api || 'http://localhost:8080/';

export const instanceApi = axios.create({
  baseURL
});
